"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.proxy = void 0;
const deleteLamps_1 = __importDefault(require("../lampModules/deleteLamps"));
const createButtonStillLamps_1 = __importDefault(require("../lampModules/createButtonStillLamps"));
const createButtonStillLamps_2 = require("../lampModules/createButtonStillLamps");
const create_1 = __importDefault(require("../lampModules/create"));
const mainObjectLamps = {
    lamps: []
};
exports.proxy = new Proxy(mainObjectLamps, {
    set: (target, prop, value) => {
        if (prop === 'lamps' && Array.isArray(value)) {
            (0, deleteLamps_1.default)();
            //console.log('%c proxy >>>', 'color: white; background: green', value.length);
            if (value.length < 13) {
                (0, createButtonStillLamps_1.default)(createButtonStillLamps_2.ComandButtonLamp.Delete);
            }
            (0, create_1.default)(value);
            target[prop] = value;
            return true;
        }
        return false;
    }
});
